import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { apiGet } from "@/lib/api-client";
import { teamKeys } from "@/lib/query";

const ClaimMaintenanceUserSchema = z.object({
  samAccountName: z.string(),
  name: z.string(),
  firstLastName: z.string().nullable(),
  title: z.string().nullable(),
  department: z.string().nullable(),
  email: z.string().nullable(),
  phoneNumber: z.string().nullable(),
  extension: z.string().nullable(),
  mobilePhone: z.string().nullable(),
  location: z.string().nullable(),
  isActiveEmployee: z.boolean(),
});

const ClaimMaintenanceUserListSchema = z.array(ClaimMaintenanceUserSchema);

export type ClaimMaintenanceUser = z.infer<typeof ClaimMaintenanceUserSchema>;

/** AD users for the Manager + User ID dropdowns on Claim Team Maintenance.
 *  Backed by legacy "User_ActiveDirectory (List) (Claims Maintenance)".
 */
export function useClaimMaintenanceUsers(search?: string) {
  return useQuery({
    queryKey: teamKeys.maintenanceUsers(search),
    queryFn: () => {
      const params = new URLSearchParams();
      if (search) params.set("search", search);
      const url = `/api/claim-maintenance-users${params.toString() ? `?${params}` : ""}`;
      return apiGet(url, ClaimMaintenanceUserListSchema);
    },
  });
}
